export const permisA2Data = {
  path: '/permis-a2',
  breadcrumb: [
    ['Formations 2 & 3 roues', '/formation'],
    ['Permis A2', '/permis-a2'],
  ],
  kicker: 'Permis moto · 35 kW max · dès 18 ans',
  title: 'Permis A2',
  titleHighlight: 'le permis principal.',
  subtitle:
    "Le permis A2 est le permis moto le plus passé en France. Il autorise toutes les motos jusqu'à 35 kW (≈ 47 ch) dès 18 ans. ETM + plateau + circulation.",
  seoTitle: 'Permis A2 — Le guide officiel : ETM, plateau, circulation, durée, prix',
  seoDescription:
    'Permis A2 (35 kW / 47 ch) : conditions, déroulement, ETM, plateau (6 manœuvres), circulation, prix moyen, durée. Le guide ECSR pour réussir du premier coup.',
  seoKeywords:
    'permis a2, permis moto a2, permis a2 prix, permis a2 duree, ETM a2, plateau a2, circulation a2, fiche plateau a2, permis moto 18 ans, 35 kW',
  heroImage:
    'https://images.unsplash.com/photo-1568772585407-9361f9bf3a87?w=2400&q=85&auto=format&fit=crop',
  heroImageAlt: 'Motard sur sa moto de 35 kW — permis A2',
  duration: '20 heures minimum',
  cost: '~ 800 à 1 200 €',
  timeRequired: 'PT20H',
  about: 'Permis A2, moto 35 kW, ETM, plateau, circulation',
  primaryCta: { label: 'Réviser l\'ETM', to: '/revision' },
  secondaryCta: { label: 'Voir le plateau', to: '/epreuves/plateau' },
  relatedTopic: 'permis-a1-a2',

  intro:
    "<p>Le <strong>permis A2</strong> est <strong>le permis moto le plus passé en France</strong>. Il autorise la conduite de toutes les motos limitées à <strong>35 kW</strong> (≈ 47 ch) et dont le rapport puissance/poids ne dépasse pas <strong>0,2 kW/kg</strong>, dès l'âge de <strong>18 ans</strong>.</p><p>Au bout de <strong>2 ans</strong> de permis A2, tu peux passer la <em>passerelle A2 → A</em> (7 heures de formation) pour accéder à toutes les motos sans limite de puissance. C'est le chemin officiel imposé par la loi pour la conduite moto en France.</p>",

  conditions: [
    {
      title: 'Avoir 18 ans révolus',
      text: 'Âge minimum strict le jour de l\'examen. Tu peux préparer l\'ETM dès 17 ans pour anticiper.',
    },
    {
      title: 'ASSR 2 ou ASR',
      text: 'Pour les candidats de moins de 21 ans : ASSR 2 (3ᵉ) ou ASR pour les non-scolarisés. Obligatoire pour l\'inscription.',
    },
    {
      title: 'JDC effectuée',
      text: 'Journée Défense et Citoyenneté validée pour les 17-25 ans (attestation à présenter au moment de l\'inscription).',
    },
    {
      title: 'Aucun antécédent bloquant',
      text: 'Pas de suspension ou annulation de permis en cours. Si tu as déjà un permis B, le tien doit être en règle.',
    },
  ],

  steps: [
    {
      title: 'Inscription en moto-école agréée',
      duration: '1 semaine',
      text: 'Choisis une moto-école avec agrément préfectoral. Le forfait moyen inclut 20h de pratique + ETM + 1 passage plateau + 1 passage circulation.',
    },
    {
      title: 'Préparer l\'ETM',
      duration: '4 à 8 semaines',
      text: 'Code moto officiel : 9 thèmes, 40 questions à l\'examen, 30 secondes/question, seuil 35/40. Préparation gratuite sur CODE 2 ROUES, examen 30€ en centre agréé.',
    },
    {
      title: 'Plateau : 8h minimum',
      duration: '2 à 4 semaines',
      text: '6 manœuvres officielles : maîtrise sans le moteur, allure lente, freinage d\'urgence, allure lente avec passager, slalom + évitement à allure élevée, récapitulatif final.',
    },
    {
      title: 'Circulation : 12h minimum',
      duration: '3 à 6 semaines',
      text: 'Conduite en ville, hors agglomération, voies rapides. Apprentissage des trajectoires de sécurité, des dépassements, des intersections, du contrôle visuel sur 360°.',
    },
    {
      title: 'Examen plateau (15 min)',
      duration: '15 minutes',
      text: 'Notation A / B / C par l\'inspecteur. Tu dois avoir A à toutes les manœuvres pour valider. Plus de 3 pieds au sol = échec automatique.',
    },
    {
      title: 'Examen circulation (30 min)',
      duration: '30 minutes',
      text: '30 min de conduite réelle. Évaluation sur 31 critères. Score minimum 17/31. Avec interphone obligatoire entre toi et l\'inspecteur.',
    },
  ],

  erreurs: [
    {
      title: 'Confondre A2 et A',
      text: 'Le A2 est limité à 35 kW. Le A (sans limite) ne s\'obtient qu\'après 2 ans de A2 + formation passerelle. Pas de A direct.',
    },
    {
      title: 'Bricoler le bridage',
      text: 'Conduire une moto > 35 kW non bridée avec le A2 = 1500 € d\'amende, suspension du permis, retrait points et annulation assurance en cas d\'accident.',
    },
    {
      title: 'Croire que la moto-école suffit',
      text: 'Les 20h légales sont un MINIMUM. La moyenne réelle est 25-30h. Mieux vaut 5h de plus que repasser un examen à 30€ + heures supplémentaires.',
    },
    {
      title: 'Sous-estimer la circulation',
      text: 'Beaucoup pensent que le plateau est le plus dur. La circulation a un taux d\'échec de ~30% sur les jeunes conducteurs. Anticipation et trajectoires sont clés.',
    },
  ],

  conseils: [
    'Vise 38/40 sur tes 3 derniers examens blancs ETM avant de réserver l\'examen théorique.',
    'Achète ton équipement complet AVANT la première heure de pratique : c\'est plus motivant et plus confortable.',
    'Demande à ton moniteur de te faire conduire dans toutes les conditions (pluie, nuit, autoroute) avant l\'examen.',
    'En examen plateau : prends ton temps. La maîtrise prime sur la vitesse.',
    'En circulation : pense \"trajectoire de sécurité\" en permanence (élargir, ralentir, regarder loin, accélérer).',
  ],

  faq: [
    {
      q: 'Quelle est la différence entre le permis A2 et le permis A ?',
      a: 'Le permis A2 est limité à 35 kW (47 ch) avec un rapport puissance/poids max de 0,2 kW/kg. Le permis A (catégorie supérieure) n\'a aucune limite de puissance. Pour passer du A2 au A, il faut 2 ans de permis A2 + une formation passerelle de 7 heures (2h théorie + 2h plateau + 3h circulation, sans examen final).',
    },
    {
      q: 'Combien coûte le permis A2 en moyenne en 2026 ?',
      a: 'Entre 800 et 1 200 € selon les régions et les moto-écoles. Le forfait inclut généralement : ETM (préparation), 20h de pratique, 1 passage plateau, 1 passage circulation. Heures supplémentaires : 40 à 55 €/h. Échec aux examens : 30 € à chaque repassage.',
    },
    {
      q: 'Quelle moto puis-je conduire avec le permis A2 ?',
      a: 'Toute moto limitée à 35 kW (47 ch) et dont le rapport puissance/poids ne dépasse pas 0,2 kW/kg. La plupart des constructeurs proposent des versions \"A2-ready\" (CB650R, MT-07, Z650, Vitpilen 401, etc.). Une moto plus puissante peut être bridée par un kit homologué (~ 200-400 €).',
    },
    {
      q: 'Que se passe-t-il si je conduis une moto non-A2 avec le permis A2 ?',
      a: 'C\'est une infraction grave : 1 500 € d\'amende, possible suspension du permis, perte de 3 points, et annulation de l\'assurance en cas d\'accident. Au-delà, le permis peut être invalidé. La police vérifie le bridage en cas de contrôle.',
    },
    {
      q: 'Combien d\'heures de pratique sont obligatoires pour le permis A2 ?',
      a: '20 heures minimum légales (8h plateau + 12h circulation). En pratique, la moyenne nationale est de 25 à 30 heures pour atteindre le niveau examen. Si tu as déjà eu une expérience moto (cyclomoteur, scooter), tu peux gagner 5-10 heures.',
    },
    {
      q: 'Combien de temps faut-il pour obtenir le permis A2 ?',
      a: 'En moyenne 3 à 6 mois entre le début de la formation et l\'obtention. Compte 1-2 mois pour l\'ETM (théorique), puis 2-4 mois pour la pratique (plateau + circulation). Les délais varient selon les disponibilités des examens dans ta région.',
    },
    {
      q: 'Le permis A2 est-il valable à l\'étranger ?',
      a: 'Le permis A2 français est valable dans tous les pays de l\'Union européenne (équivalence directe). Hors UE : à vérifier au cas par cas (la plupart des pays demandent un permis international en complément).',
    },
  ],

  sourceLabel:
    'Code de la route articles R221-3 et suivants, programme ETM 2026 (REMC), arrêté du 19 février 2010 modifié.',
  sourceUrl: 'https://www.securite-routiere.gouv.fr/passer-son-permis-de-conduire/permis-moto',
};
